import React from 'react';
import { SectionListQuestionListItem } from './SectionListQuestionListItem';
import { SectionListSectionListItem } from './SectionListSectionListItem';

type Props = {
  type: 'folder' | 'section' | 'question';
  id: number;
  level: number;
  last: boolean;
};

export const SectionListItem: React.FC<Props> = React.memo(
  ({ type, id, level, last }) => {
    if (type === 'question') {
      return <SectionListQuestionListItem id={id} level={level} last={last} />;
    }
    return <SectionListSectionListItem id={id} />;
  },
);
